var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubdirectoryArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18998_732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18998_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 56.0003L33.5333 52.2003L43.1333 42.667H13.3333V10.667H18.6666V37.3337H43.1333L33.5333 27.7337L37.2666 23.9337L53.3333 40.0003L37.3333 56.0003Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdirectoryArrowRight);
export default __webpack_public_path__ + "static/media/subdirectory-arrow-right.8d3405f34fb60f3b0c2e9bd9f375bc2a.svg";
export { ForwardRef as ReactComponent };